<template lang="pug">
  div.map-popup.map-popup-tko
    div(v-if="loading")
      div.tooltip__head
        p.title Загрузка...
        span(@click="close($event)").close.close--small.close--tooltip
      div.tooltip__body
        div.spinner
          div.rect1
          div.rect2
          div.rect3
          div.rect4
          div.rect5

    div(v-else-if="error")
      div.tooltip__head
        p.title Ошибка
        span(@click="close($event)").close.close--small.close--tooltip

    div(v-else-if="!loading")
      div.tooltip__head
        p.title {{head}}
        span(@click="close($event)").close.close--small.close--tooltip
      div.tooltip__body
        popup-fields-rows(:rows="rows" :model="fields")
        // div.tooltip__body-table
          div.table
            table
              thead
                th Технология
                th Мощность
                th Пришло
              tbody
                tr
                  td Рециклинг
                  td n/a
                  td n/a
        div(v-if="loadingPercent").tooltip__body-bar
          div Загрузка объекта: {{loadingPercent}}%
          div.progressbar
            div.progressbar.progressbar--loaded(:style="{'width': loadingPercent + '%'}")

      div.tooltip__foot
        button(v-if="showMore" @click.prevent="more") Подробнее
</template>

<script>
  import {map as mapEndpoints}        from '../../api/api-endpoints.js'
  import baseMapPopupMixin            from './base-map-popup-mixin.js'
  import PopupFieldsRows              from './popup-fields-rows.vue'
  import { ICON_TYPE_ROUTE_NAME_MAP } from '@/config/map'
  /*
   active  - зеленый
   planned - желтый

   */
  export default {
    components: {PopupFieldsRows},
    mixins: [baseMapPopupMixin],
    name: 'map-popup-tko',
    data () {
      this.closeCallback = null
      this.redirectParams = {}
      return {
        fields: {}
      }
    },
    computed: {
      loadingPercent () {
        if (this.markerModel.percentOfLoading && this.markerModel.power) {
          let percent = Math.round(this.markerModel.percentOfLoading)
          console.log('Current percent', percent)
          // @fix: max percent is 100%
          if (percent > 100) {
            percent = 100
          }
          return percent
        }
        return null
      }
    },
    methods: {
      injectConf (options) {
        let {model, closeCallback, redirectParams = null} = options
        this.closeCallback = closeCallback
        this.markerModel = Object.assign({}, model || {})
        this.fields = Object.assign({}, model || {})
        this.registerVueInMap()
        let endpoint = mapEndpoints.object('', {query: {id: (model.tko_object_id || model.id)}})
        this.fetchGeoObjectPopupData(endpoint)
        if (redirectParams) {
          this.redirectParams = redirectParams
        }
      },
      close ($event) {
        this.closeCallback($event)
      }
    }
  }
</script>
